import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../history';
import { 
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from 'react-share';

// Actions

// Style
import '../../styles/components/post/post.scss';

// Assets

class Post extends Component {

    constructor(props) {
        super(props);

        this.navigateTo = this.navigateTo.bind(this);
    }

    navigateTo(url) {
        window.scrollTo(0,0);
        history.push(url);
    }

    render() {
        const shareUrl = `${window.location.origin}${this.props.postUrl}`;

        return (
            <div 
                className="PPAPost"
            >
                <div className="postBody">
                    {
                        this.props.title ? (
                            <div className="title">
                                {this.props.title}
                            </div>
                        ) : ''
                    }
                    {
                        this.props.imgSrc ? (
                            <div className="img-container">
                                {
                                    this.props.type &&
                                    this.props.type.split('/')[0] === 'video' ? (
                                        <div className="img">
                                            <video controls>
                                                <source src={`${this.props.imgSrc}#t=0.001`} type={this.props.type} />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    ) : (
                                        <div className="img">
                                            <img src={this.props.imgSrc} alt={this.props.imgAlt || ''} />
                                        </div>
                                    )
                                }
                                
                                {
                                    this.props.date ? (
                                        <div className="date">
                                            {this.props.date}
                                        </div>
                                    ) : ''
                                }
                            </div>
                        ) : ''
                    }
                    
                    {
                        this.props.content ? (
                            <div className="content-container">
                                <div className="content">
                                    {this.props.content}
                                </div>
                            </div>
                        ) : ''
                    }
                    {
                        this.props.postUrl ? (
                            <div className="readMore">
                                <button
                                    type="button"
                                    className="btn-link"
                                    onClick={() => this.navigateTo(this.props.postUrl)}
                                >
                                    Read More
                                </button>
                            </div>
                        ) : ''
                    }
                    {
                        this.props.showSharingOptions ? (
                            <div className="sharing">
                                <p className="shareTitle">Share</p>
                                <ul className="sharing-options">
                                    <li className="sharing-item">
                                        <TwitterShareButton 
                                            url={shareUrl}
                                            className="sharing-link"
                                        >
                                                <svg 
                                                    className="social-icon"
                                                    viewBox="0 0 22 21" 
                                                    fill="none" 
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path 
                                                        d="M21.235 2.09998L21.7338 2.06533C21.7201 1.86719 21.5903 1.69598 21.4033 1.62914C21.2163 1.5623 21.0074 1.6125 20.8712 1.75705L21.235 2.09998ZM20.2706 6.24244C20.2706 5.9663 20.0468 5.74244 19.7706 5.74244C19.4945 5.74244 19.2706 5.9663 19.2706 6.24244H20.2706ZM10.9842 6.35751H10.4842V6.35751L10.9842 6.35751ZM10.9842 7.69998L11.4842 7.69998V7.69998L10.9842 7.69998ZM0.733398 17.5V17C0.511161 17 0.315597 17.1467 0.253387 17.36C0.191178 17.5734 0.277256 17.8022 0.464666 17.9216L0.733398 17.5ZM2.1978 2.09998L2.66327 1.91739C2.59176 1.73507 2.42037 1.61128 2.22481 1.60071C2.02924 1.59013 1.84551 1.6947 1.75474 1.86825L2.1978 2.09998ZM8.05541 14.7L8.40093 15.0614C8.52849 14.9394 8.58231 14.7593 8.54256 14.5873C8.50281 14.4154 8.37537 14.2772 8.20723 14.2236L8.05541 14.7ZM18.6503 3.46271L18.2873 3.80656L18.4654 3.99463L18.7218 3.95756L18.6503 3.46271ZM20.7362 2.13462C20.8125 3.23215 20.7442 3.92174 20.5465 4.4538C20.3522 4.97654 20.0134 5.40034 19.4332 5.93103L20.1081 6.66892C20.738 6.09276 21.2094 5.54066 21.4839 4.80216C21.7548 4.07298 21.8138 3.216 21.7338 2.06533L20.7362 2.13462ZM20.2706 7.26247V6.24244H19.2706V7.26247H20.2706ZM10.4842 6.35751L10.4842 7.69998L11.4842 7.69998L11.4842 6.35751L10.4842 6.35751ZM10.4842 7.69998L10.4842 8.39997L11.4842 8.39998L11.4842 7.69998L10.4842 7.69998ZM15.4376 1.59998C12.7234 1.59998 10.4842 3.70904 10.4842 6.35751H11.4842C11.4842 4.30324 13.2328 2.59998 15.4376 2.59998V1.59998ZM19.2706 7.26247C19.2706 13.3926 14.0659 18.4 7.59778 18.4V19.4C14.5754 19.4 20.2706 13.9868 20.2706 7.26247H19.2706ZM1.73233 2.28256C2.51459 4.27684 5.44574 8.19998 10.9842 8.19998V7.19998C5.979 7.19998 3.34542 3.65645 2.66327 1.91739L1.73233 2.28256ZM1.75474 1.86825C0.238536 4.7673 0.0152613 7.55828 1.10292 9.92152C2.18671 12.2764 4.52302 14.0991 7.9036 15.1764L8.20723 14.2236C4.99799 13.2009 2.94109 11.5236 2.01133 9.50343C1.08543 7.49167 1.22826 5.03266 2.64086 2.3317L1.75474 1.86825ZM7.70989 14.3386C6.79948 15.209 4.08598 17 0.733398 17V18C4.40995 18 7.35884 16.0577 8.40093 15.0614L7.70989 14.3386ZM19.0133 3.11886C18.1273 2.1836 16.851 1.59998 15.4376 1.59998V2.59998C16.5725 2.59998 17.5876 3.06787 18.2873 3.80656L19.0133 3.11886ZM18.7218 3.95756C19.776 3.80516 20.8151 3.27459 21.5989 2.4429L20.8712 1.75705C20.2404 2.42636 19.4066 2.84817 18.5787 2.96785L18.7218 3.95756ZM0.464666 17.9216C2.80121 19.4108 5.2485 19.4 7.59778 19.4V18.4C5.21439 18.4 3.0588 18.3891 1.00213 17.0783L0.464666 17.9216Z" 
                                                        fill="black"
                                                    />
                                                </svg>
                                        </TwitterShareButton>
                                    </li>
                                    <li className="sharing-item">
                                        <FacebookShareButton 
                                            url={shareUrl}
                                            className="sharing-link"
                                        >
                                            <svg 
                                                className="social-icon"
                                                viewBox="0 0 22 21" 
                                                fill="none" 
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path 
                                                    d="M11.0001 20.2999C5.32994 20.2999 0.733398 15.9123 0.733398 10.5C0.733398 5.08756 5.32994 0.699951 11.0001 0.699951C16.6702 0.699951 21.2667 5.08756 21.2667 10.5C21.2667 15.9123 16.6702 20.2999 11.0001 20.2999ZM11.0001 20.2999V9.09995C11.0001 7.55355 12.3134 6.29995 13.9334 6.29995H14.6667M7.3334 11.9H14.6667" 
                                                    stroke="black"
                                                />
                                            </svg>
                                        </FacebookShareButton>
                                    </li>
                                    <li className="sharing-item">
                                        <WhatsappShareButton
                                            url={shareUrl}
                                            className="sharing-link"
                                        >
                                            <svg 
                                                className="social-icon"
                                                viewBox="0 0 22 21" 
                                                fill="none" 
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path 
                                                    d="M2.78643 16.3805L3.22935 16.6125L3.37958 16.3257L3.17934 16.0713L2.78643 16.3805ZM4.83946 18.3402L5.13084 17.9339L4.89074 17.7617L4.6241 17.889L4.83946 18.3402ZM0.733398 20.2999L0.290483 20.0679C0.190599 20.2586 0.223973 20.4918 0.373328 20.6469C0.522684 20.8019 0.754493 20.8439 0.948763 20.7512L0.733398 20.2999ZM6.60006 6.29995L6.33163 5.87812C6.1874 5.9699 6.10006 6.129 6.10006 6.29995H6.60006ZM15.4001 14.6999V15.1999C15.5634 15.1999 15.7165 15.1202 15.81 14.9862L15.4001 14.6999ZM9.17298 7.03571L9.66552 6.94971V6.94971L9.17298 7.03571ZM9.37749 8.20705L8.88495 8.29305L9.37749 8.20705ZM8.74434 9.60208L9.01278 10.0239L8.74434 9.60208ZM15.6085 14.4015L15.1986 14.1152L15.6085 14.4015ZM14.6293 12.244L14.7078 11.7502H14.7078L14.6293 12.244ZM13.4022 12.0488L13.3236 12.5426L13.4022 12.0488ZM11.9407 12.6531L11.5308 12.3668L11.9407 12.6531ZM0.233398 10.5C0.233398 12.8245 1.03876 14.9684 2.39352 16.6898L3.17934 16.0713C1.95585 14.5167 1.2334 12.5883 1.2334 10.5H0.233398ZM11.0001 0.199951C5.07597 0.199951 0.233398 4.78975 0.233398 10.5H1.2334C1.2334 5.38537 5.58391 1.19995 11.0001 1.19995V0.199951ZM21.7667 10.5C21.7667 4.78975 16.9242 0.199951 11.0001 0.199951V1.19995C16.4162 1.19995 20.7667 5.38537 20.7667 10.5H21.7667ZM11.0001 20.7999C16.9242 20.7999 21.7667 16.2101 21.7667 10.5H20.7667C20.7667 15.6145 16.4162 19.7999 11.0001 19.7999V20.7999ZM4.54809 18.7466C6.34762 20.037 8.5823 20.7999 11.0001 20.7999V19.7999C8.7948 19.7999 6.76329 19.1045 5.13084 17.9339L4.54809 18.7466ZM0.948763 20.7512L5.05483 18.7915L4.6241 17.889L0.518034 19.8487L0.948763 20.7512ZM2.34352 16.1485L0.290483 20.0679L1.17631 20.532L3.22935 16.6125L2.34352 16.1485ZM6.10006 6.29995V7.69995H7.10006V6.29995H6.10006ZM13.9334 15.1999H15.4001V14.1999H13.9334V15.1999ZM6.10006 7.69995C6.10006 11.8638 9.62934 15.1999 13.9334 15.1999V14.1999C10.1373 14.1999 7.10006 11.2681 7.10006 7.69995H6.10006ZM6.8685 6.72178L7.18114 6.52283L6.64427 5.67917L6.33163 5.87812L6.8685 6.72178ZM8.68043 7.12171L8.88495 8.29305L9.87004 8.12105L9.66552 6.94971L8.68043 7.12171ZM8.47591 9.18025L7.06496 10.0781L7.60184 10.9218L9.01278 10.0239L8.47591 9.18025ZM8.88495 8.29305C8.94365 8.62927 8.79281 8.97858 8.47591 9.18025L9.01278 10.0239C9.65631 9.61439 10.0011 8.87167 9.87004 8.12105L8.88495 8.29305ZM7.18114 6.52283C7.78982 6.13549 8.5716 6.49845 8.68043 7.12171L9.66552 6.94971C9.42441 5.56878 7.80668 4.93945 6.64427 5.67917L7.18114 6.52283ZM15.81 14.9862L16.0184 14.6878L15.1986 14.1152L14.9901 14.4137L15.81 14.9862ZM14.7078 11.7502L13.4807 11.555L13.3236 12.5426L14.5507 12.7378L14.7078 11.7502ZM11.5308 12.3668L10.5901 13.7137L11.41 14.2862L12.3506 12.9394L11.5308 12.3668ZM13.4807 11.555C12.7298 11.4355 11.9648 11.7453 11.5308 12.3668L12.3506 12.9394C12.5568 12.6442 12.9359 12.4809 13.3236 12.5426L13.4807 11.555ZM16.0184 14.6878C16.8375 13.515 16.0917 11.9704 14.7078 11.7502L14.5507 12.7378C15.2665 12.8516 15.5602 13.5975 15.1986 14.1152L16.0184 14.6878Z" 
                                                    fill="black"
                                                />
                                            </svg>
                                        </WhatsappShareButton>
                                    </li>
                                </ul>
                            </div>
                        ) : ''
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({

});

export default connect(mapStateToProps, { 

})(Post);